import React from 'react';
import { X, AlertTriangle, BookOpen, Mail, Layers, Clock } from 'lucide-react';
interface AdminDetailPanelProps {
  detailPanel: {
    type: string;
    data: any;
    title?: string;
  } | null;
  setDetailPanel: (panel: any) => void;
}
export function AdminDetailPanel({
  detailPanel,
  setDetailPanel
}: AdminDetailPanelProps) {
  if (!detailPanel) return null;
  return <div className="fixed inset-0 z-50 flex justify-end bg-slate-900/20 backdrop-blur-sm" onClick={e => {
    if (e.target === e.currentTarget) setDetailPanel(null);
  }} data-id="element-3390">
      <div className="w-full max-w-lg bg-white shadow-2xl flex flex-col h-full" data-id="element-3391">
        <div className="h-12 border-b border-slate-100 flex items-center justify-between px-5 bg-slate-50/50" data-id="element-3392">
          <h3 className="text-sm font-bold text-slate-900" data-id="element-3393">
            {detailPanel.title || 'Детали'}
          </h3>
          <button className="p-1.5 text-slate-400 hover:text-slate-600 rounded-md hover:bg-slate-100" onClick={() => setDetailPanel(null)} data-id="element-3394">
            <X className="w-4 h-4" data-id="element-3395" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-5" data-id="element-3396">
          {/* User Detail */}
          {detailPanel.type === 'user' && detailPanel.data && <div className="space-y-4" data-id="element-3397">
              <div className="flex items-center gap-3" data-id="element-3398">
                <div className="w-12 h-12 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold text-lg" data-id="element-3399">
                  {(detailPanel.data.name || '').split(' ').map((n: string) => n[0]).join('')}
                </div>
                <div data-id="element-3400">
                  <h3 className="font-bold text-slate-900" data-id="element-3401">
                    {detailPanel.data.name}
                  </h3>
                  <p className="text-xs text-slate-500" data-id="element-3402">
                    {detailPanel.data.email}
                  </p>
                </div>
              </div>
              <div className="bg-slate-50 rounded-lg divide-y divide-slate-200" data-id="element-3403">
                {[['ID', detailPanel.data.id], ['Статус', detailPanel.data.status], ['Регистрация', detailPanel.data.date], ['Последний вход', detailPanel.data.lastLogin], ['Баланс', `${(detailPanel.data.balance || 0).toLocaleString('ru-RU')} ₽`], ['Заказов', detailPanel.data.orders], ['Потрачено', detailPanel.data.spent], ['Подписка', detailPanel.data.subscription || 'Нет'], ['Страна', detailPanel.data.country], ['Телефон', detailPanel.data.phone]].map(([label, value], i) => <div key={i} className="flex justify-between px-4 py-2.5" data-id="element-3404">
                    <span className="text-xs text-slate-500" data-id="element-3405">{label}</span>
                    <span className="text-xs font-bold text-slate-900" data-id="element-3406">
                      {value}
                    </span>
                  </div>)}
              </div>
              {detailPanel.data.notes && <div className="bg-amber-50 rounded-lg p-3" data-id="element-3407">
                  <div className="text-xs font-bold text-amber-800 mb-1" data-id="element-3408">
                    Заметки
                  </div>
                  <div className="text-xs text-amber-700" data-id="element-3409">
                    {detailPanel.data.notes}
                  </div>
                </div>}
            </div>}

          {/* Order Detail */}
          {detailPanel.type === 'order' && detailPanel.data && <div className="space-y-4" data-id="element-3410">
              <div className="bg-slate-50 rounded-lg p-4" data-id="element-3411">
                <div className="text-sm font-bold text-slate-900 mb-1" data-id="element-3412">
                  Заказ {detailPanel.data.id}
                </div>
                <div className="text-xs text-slate-500" data-id="element-3413">
                  от {detailPanel.data.date}
                </div>
              </div>
              <div className="bg-slate-50 rounded-lg divide-y divide-slate-200" data-id="element-3414">
                {[['Клиент', detailPanel.data.client], ['Услуга', detailPanel.data.service], ['Астролог', detailPanel.data.astrologer], ['Сумма', detailPanel.data.amount], ['Статус', detailPanel.data.status], ['Оплата', detailPanel.data.payment]].map(([label, value], i) => <div key={i} className="flex justify-between px-4 py-2.5" data-id="element-3415">
                    <span className="text-xs text-slate-500" data-id="element-3416">{label}</span>
                    <span className="text-xs font-bold text-slate-900" data-id="element-3417">
                      {value}
                    </span>
                  </div>)}
              </div>
            </div>}

          {/* Astrologer Detail */}
          {detailPanel.type === 'astrologer' && detailPanel.data && <div className="space-y-4" data-id="element-3418">
              <div className="flex items-center gap-3" data-id="element-3419">
                <div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center text-purple-600 font-bold text-lg" data-id="element-3420">
                  {(detailPanel.data.name || '').split(' ').map((n: string) => n[0]).join('')}
                </div>
                <div data-id="element-3421">
                  <h3 className="font-bold text-slate-900" data-id="element-3422">
                    {detailPanel.data.name}
                  </h3>
                  <p className="text-xs text-slate-500" data-id="element-3423">
                    {detailPanel.data.spec}
                  </p>
                </div>
              </div>
              <div className="bg-slate-50 rounded-lg divide-y divide-slate-200" data-id="element-3424">
                {[['ID', detailPanel.data.id], ['Email', detailPanel.data.email], ['Рейтинг', `⭐ ${detailPanel.data.rating}`], ['Отзывов', detailPanel.data.reviews], ['Заказов', detailPanel.data.orders], ['Заработано', detailPanel.data.earnings], ['Статус', detailPanel.data.status], ['Верификация', detailPanel.data.verified ? 'Да' : 'Нет']].map(([label, value], i) => <div key={i} className="flex justify-between px-4 py-2.5" data-id="element-3425">
                    <span className="text-xs text-slate-500" data-id="element-3426">{label}</span>
                    <span className="text-xs font-bold text-slate-900" data-id="element-3427">
                      {value}
                    </span>
                  </div>)}
              </div>
            </div>}

          {/* Ad Placement Detail */}
          {detailPanel.type === 'ad-placement' && detailPanel.data && <div className="space-y-4" data-id="element-3428">
              <div className="flex items-center gap-3" data-id="element-3429">
                <div className="w-12 h-12 rounded-xl bg-indigo-50 flex items-center justify-center text-indigo-600 font-bold text-lg" data-id="element-3430">
                  {detailPanel.data.type === 'Баннер' ? '🖼️' : '📝'}
                </div>
                <div data-id="element-3431">
                  <h3 className="font-bold text-slate-900" data-id="element-3432">
                    {detailPanel.data.object}
                  </h3>
                  <p className="text-xs text-slate-500" data-id="element-3433">
                    {detailPanel.data.id}
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3" data-id="element-3434">
                <div className="bg-slate-50 rounded-lg p-3" data-id="element-3435">
                  <span className="text-[10px] text-slate-500 block" data-id="element-3436">
                    Статус
                  </span>
                  <span className={`text-sm font-bold ${detailPanel.data.status === 'active' ? 'text-emerald-600' : 'text-slate-700'}`} data-id="element-3437">
                    {detailPanel.data.status === 'active' ? 'Активно' : detailPanel.data.status === 'paused' ? 'На паузе' : detailPanel.data.status === 'completed' ? 'Завершено' : detailPanel.data.status === 'queued' ? 'В очереди' : detailPanel.data.status === 'scheduled' ? 'Запланировано' : detailPanel.data.status}
                  </span>
                </div>
                <div className="bg-slate-50 rounded-lg p-3" data-id="element-3438">
                  <span className="text-[10px] text-slate-500 block" data-id="element-3439">
                    Оплата
                  </span>
                  <span className={`text-sm font-bold ${detailPanel.data.payment === 'paid' ? 'text-emerald-600' : 'text-amber-600'}`} data-id="element-3440">
                    {detailPanel.data.payment === 'paid' ? 'Оплачено' : 'Ожидает'}
                  </span>
                </div>
              </div>

              <div className="bg-slate-50 rounded-lg divide-y divide-slate-200" data-id="element-3441">
                {[['Рекламодатель', detailPanel.data.advertiser], ['Слот', detailPanel.data.slotName], ['Тип', detailPanel.data.type], ['Период', `${detailPanel.data.periodStart} — ${detailPanel.data.periodEnd}`], ['Стоимость', `${(detailPanel.data.price || 0).toLocaleString('ru-RU')} ₽`], ['Приоритет', `${detailPanel.data.priority}/10`], ['Автопродление', detailPanel.data.autoRenew ? 'Включено' : 'Выключено'], ['Таймер', detailPanel.data.timer]].map(([label, value], i) => <div key={i} className="flex justify-between px-4 py-2.5" data-id="element-3442">
                    <span className="text-xs text-slate-500" data-id="element-3443">{label}</span>
                    <span className="text-xs font-bold text-slate-900" data-id="element-3444">
                      {value}
                    </span>
                  </div>)}
              </div>

              {detailPanel.data.impressionsPlan > 0 && <div data-id="element-3445">
                  <div className="flex justify-between text-xs mb-1.5" data-id="element-3446">
                    <span className="font-medium text-slate-700" data-id="element-3447">Показы</span>
                    <span className="text-slate-500" data-id="element-3448">
                      {(detailPanel.data.impressionsFact || 0).toLocaleString('ru-RU')}{' '}
                      /{' '}
                      {(detailPanel.data.impressionsPlan || 0).toLocaleString('ru-RU')}
                    </span>
                  </div>
                  <div className="w-full bg-slate-100 rounded-full h-2" data-id="element-3449">
                    <div className={`h-2 rounded-full transition-all ${detailPanel.data.impressionsFact / detailPanel.data.impressionsPlan >= 0.95 ? 'bg-rose-500' : detailPanel.data.impressionsFact / detailPanel.data.impressionsPlan >= 0.8 ? 'bg-amber-500' : 'bg-indigo-500'}`} style={{
                width: `${Math.min(100, detailPanel.data.impressionsFact / detailPanel.data.impressionsPlan * 100)}%`
              }} data-id="element-3450" />
                  </div>
                </div>}

              <div className="grid grid-cols-3 gap-3" data-id="element-3451">
                <div className="bg-blue-50 rounded-lg p-3 text-center" data-id="element-3452">
                  <div className="text-lg font-bold text-blue-700" data-id="element-3453">
                    {(detailPanel.data.impressionsFact || 0).toLocaleString('ru-RU')}
                  </div>
                  <div className="text-[10px] text-blue-600 font-medium" data-id="element-3454">
                    Показы
                  </div>
                </div>
                <div className="bg-purple-50 rounded-lg p-3 text-center" data-id="element-3455">
                  <div className="text-lg font-bold text-purple-700" data-id="element-3456">
                    {(detailPanel.data.clicks || 0).toLocaleString('ru-RU')}
                  </div>
                  <div className="text-[10px] text-purple-600 font-medium" data-id="element-3457">
                    Клики
                  </div>
                </div>
                <div className="bg-amber-50 rounded-lg p-3 text-center" data-id="element-3458">
                  <div className="text-lg font-bold text-amber-700" data-id="element-3459">
                    {detailPanel.data.ctr}
                  </div>
                  <div className="text-[10px] text-amber-600 font-medium" data-id="element-3460">
                    CTR
                  </div>
                </div>
              </div>

              {detailPanel.data.slotCapacity && <div className="bg-slate-50 rounded-lg p-3" data-id="element-3461">
                  <div className="text-xs font-bold text-slate-700 mb-2" data-id="element-3462">
                    Ёмкость слота
                  </div>
                  <div className="flex gap-4 text-xs" data-id="element-3463">
                    <span data-id="element-3464">
                      Лимит:{' '}
                      <strong data-id="element-3465">{detailPanel.data.slotCapacity.limit}</strong>
                    </span>
                    <span data-id="element-3466">
                      Активных:{' '}
                      <strong className="text-emerald-600" data-id="element-3467">
                        {detailPanel.data.slotCapacity.active}
                      </strong>
                    </span>
                    <span data-id="element-3468">
                      В очереди:{' '}
                      <strong className="text-blue-600" data-id="element-3469">
                        {detailPanel.data.slotCapacity.queued}
                      </strong>
                    </span>
                  </div>
                </div>}
            </div>}

          {/* Featured Astrologer Detail */}
          {detailPanel.type === 'featured-astrologer' && detailPanel.data && <div className="space-y-4" data-id="element-3470">
              <div className="flex items-center gap-3" data-id="element-3471">
                <div className="w-12 h-12 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold text-lg" data-id="element-3472">
                  {(detailPanel.data.astrologer || '').split(' ').map((n: string) => n[0]).join('')}
                </div>
                <div data-id="element-3473">
                  <h3 className="font-bold text-slate-900" data-id="element-3474">
                    {detailPanel.data.astrologer}
                  </h3>
                  <p className="text-xs text-slate-500" data-id="element-3475">
                    Закреплённый астролог • {detailPanel.data.position}
                  </p>
                </div>
              </div>
              <div className="bg-slate-50 rounded-lg divide-y divide-slate-200" data-id="element-3476">
                {[['Позиция', detailPanel.data.position], ['Период', detailPanel.data.period], ['Стоимость', `${(detailPanel.data.price || 0).toLocaleString('ru-RU')} ₽`], ['Показы', detailPanel.data.impressions], ['Клики', detailPanel.data.clicks], ['CTR', detailPanel.data.ctr], ['Бронирования', `${detailPanel.data.bookings}`], ['Статус', detailPanel.data.status === 'active' ? 'Активно' : detailPanel.data.status === 'scheduled' ? 'Запланировано' : detailPanel.data.status]].map(([label, value], i) => <div key={i} className="flex justify-between px-4 py-2.5" data-id="element-3477">
                    <span className="text-xs text-slate-500" data-id="element-3478">{label}</span>
                    <span className="text-xs font-bold text-slate-900" data-id="element-3479">
                      {value}
                    </span>
                  </div>)}
              </div>
            </div>}

          {/* Featured Course Detail */}
          {detailPanel.type === 'featured-course' && detailPanel.data && <div className="space-y-4" data-id="element-3480">
              <div className="flex items-center gap-3" data-id="element-3481">
                <div className="w-12 h-12 rounded-xl bg-purple-50 flex items-center justify-center text-purple-600" data-id="element-3482">
                  <BookOpen className="w-6 h-6" data-id="element-3483" />
                </div>
                <div data-id="element-3484">
                  <h3 className="font-bold text-slate-900" data-id="element-3485">
                    {detailPanel.data.course}
                  </h3>
                  <p className="text-xs text-slate-500" data-id="element-3486">
                    Закреплённый курс • {detailPanel.data.position}
                  </p>
                </div>
              </div>
              <div className="bg-slate-50 rounded-lg divide-y divide-slate-200" data-id="element-3487">
                {[['Позиция', detailPanel.data.position], ['Период', detailPanel.data.period], ['Стоимость', `${(detailPanel.data.price || 0).toLocaleString('ru-RU')} ₽`], ['Показы', detailPanel.data.impressions], ['Клики', detailPanel.data.clicks], ['CTR', detailPanel.data.ctr], ['Покупки', `${detailPanel.data.purchases}`], ['Статус', detailPanel.data.status === 'active' ? 'Активно' : detailPanel.data.status === 'scheduled' ? 'Запланировано' : detailPanel.data.status]].map(([label, value], i) => <div key={i} className="flex justify-between px-4 py-2.5" data-id="element-3488">
                    <span className="text-xs text-slate-500" data-id="element-3489">{label}</span>
                    <span className="text-xs font-bold text-slate-900" data-id="element-3490">
                      {value}
                    </span>
                  </div>)}
              </div>
            </div>}

          {/* Email Campaign Detail */}
          {detailPanel.type === 'email-campaign' && detailPanel.data && <div className="space-y-4" data-id="element-3491">
              <div className="flex items-center gap-3" data-id="element-3492">
                <div className="w-12 h-12 rounded-xl bg-emerald-50 flex items-center justify-center text-emerald-600" data-id="element-3493">
                  <Mail className="w-6 h-6" data-id="element-3494" />
                </div>
                <div data-id="element-3495">
                  <h3 className="font-bold text-slate-900" data-id="element-3496">
                    {detailPanel.data.name}
                  </h3>
                  <p className="text-xs text-slate-500" data-id="element-3497">
                    {detailPanel.data.id} • Email-кампания
                  </p>
                </div>
              </div>
              <div className="bg-slate-50 rounded-lg divide-y divide-slate-200" data-id="element-3498">
                {[['Дата', detailPanel.data.date], ['Отправлено', detailPanel.data.sent], ['Open Rate', detailPanel.data.openRate], ['CTR', detailPanel.data.ctr], ['Конверсии', `${detailPanel.data.conversions}`], ['Доход', `${(detailPanel.data.revenue || 0).toLocaleString('ru-RU')} ₽`], ['Статус', detailPanel.data.status === 'sent' ? 'Отправлено' : 'Запланировано']].map(([label, value], i) => <div key={i} className="flex justify-between px-4 py-2.5" data-id="element-3499">
                    <span className="text-xs text-slate-500" data-id="element-3500">{label}</span>
                    <span className="text-xs font-bold text-slate-900" data-id="element-3501">
                      {value}
                    </span>
                  </div>)}
              </div>
            </div>}

          {/* Slot Detail */}
          {detailPanel.type === 'slot-detail' && detailPanel.data && <div className="space-y-4" data-id="element-3502">
              <div className="flex items-center gap-3" data-id="element-3503">
                <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center text-blue-600" data-id="element-3504">
                  <Layers className="w-6 h-6" data-id="element-3505" />
                </div>
                <div data-id="element-3506">
                  <h3 className="font-bold text-slate-900" data-id="element-3507">
                    {detailPanel.data.name}
                  </h3>
                  <p className="text-xs text-slate-500" data-id="element-3508">
                    {detailPanel.data.id} • {detailPanel.data.page}
                  </p>
                </div>
              </div>
              <div className="bg-slate-50 rounded-lg divide-y divide-slate-200" data-id="element-3509">
                {[['Страница', detailPanel.data.page], ['Тип', detailPanel.data.type], ['Размер', detailPanel.data.size], ['Базовая цена', `${(detailPanel.data.basePrice || 0).toLocaleString('ru-RU')} ₽`], ['Лимит', `${detailPanel.data.limit}`], ['Активных', `${detailPanel.data.active}`], ['В очереди', `${detailPanel.data.queued}`], ['Ротация', detailPanel.data.rotation], ['Длительность', `${detailPanel.data.duration} дн.`], ['Fill Rate', `${detailPanel.data.fillRate}%`], ['Статус', detailPanel.data.status === 'active' ? 'Активен' : detailPanel.data.status === 'paused' ? 'На паузе' : detailPanel.data.status]].filter(([, v]) => v !== undefined && v !== null).map(([label, value], i) => <div key={i} className="flex justify-between px-4 py-2.5" data-id="element-3510">
                      <span className="text-xs text-slate-500" data-id="element-3511">{label}</span>
                      <span className="text-xs font-bold text-slate-900" data-id="element-3512">
                        {value}
                      </span>
                    </div>)}
              </div>
              {detailPanel.data.events && detailPanel.data.events.length > 0 && <div data-id="element-3513">
                    <div className="text-xs font-bold text-slate-700 mb-2" data-id="element-3514">
                      Последние события
                    </div>
                    <div className="space-y-2" data-id="element-3515">
                      {detailPanel.data.events.map((ev: any, i: number) => <div key={i} className="flex items-start gap-2 bg-slate-50 rounded-lg p-2.5" data-id="element-3516">
                          <div className="w-1.5 h-1.5 rounded-full bg-indigo-400 mt-1.5 shrink-0" data-id="element-3517" />
                          <div data-id="element-3518">
                            <div className="text-xs text-slate-700" data-id="element-3519">
                              {ev.description}
                            </div>
                            <div className="text-[10px] text-slate-400" data-id="element-3520">
                              {ev.time}
                            </div>
                          </div>
                        </div>)}
                    </div>
                  </div>}
            </div>}

          {/* Queue Item Detail */}
          {detailPanel.type === 'queue-item' && detailPanel.data && <div className="space-y-4" data-id="element-3521">
              <div className="flex items-center gap-3" data-id="element-3522">
                <div className="w-12 h-12 rounded-xl bg-amber-50 flex items-center justify-center text-amber-600" data-id="element-3523">
                  <Clock className="w-6 h-6" data-id="element-3524" />
                </div>
                <div data-id="element-3525">
                  <h3 className="font-bold text-slate-900" data-id="element-3526">
                    {detailPanel.data.object}
                  </h3>
                  <p className="text-xs text-slate-500" data-id="element-3527">
                    {detailPanel.data.id} • Позиция #
                    {detailPanel.data.queuePosition}
                  </p>
                </div>
              </div>
              <div className="bg-slate-50 rounded-lg divide-y divide-slate-200" data-id="element-3528">
                {[['Рекламодатель', detailPanel.data.advertiser], ['Слот', detailPanel.data.slotName], ['Тип', detailPanel.data.type], ['Период', `${detailPanel.data.periodStart} — ${detailPanel.data.periodEnd}`], ['Стоимость', `${(detailPanel.data.price || 0).toLocaleString('ru-RU')} ₽`], ['Приоритет', `${detailPanel.data.priority}/10`], ['Тип очереди', detailPanel.data.queueType], ['Оплата', detailPanel.data.paymentStatus === 'paid' ? 'Оплачено' : 'Ожидает'], ['Слот освободится', detailPanel.data.slotFreeTimer || '—'], ['Fast Track', detailPanel.data.fastTrack ? 'Да' : 'Нет']].map(([label, value], i) => <div key={i} className="flex justify-between px-4 py-2.5" data-id="element-3529">
                    <span className="text-xs text-slate-500" data-id="element-3530">{label}</span>
                    <span className="text-xs font-bold text-slate-900" data-id="element-3531">
                      {value}
                    </span>
                  </div>)}
              </div>
              {detailPanel.data.conflict && <div className="bg-rose-50 border border-rose-200 rounded-lg p-3 flex items-start gap-2" data-id="element-3532">
                  <AlertTriangle className="w-4 h-4 text-rose-500 mt-0.5 shrink-0" data-id="element-3533" />
                  <div data-id="element-3534">
                    <div className="text-xs font-bold text-rose-700" data-id="element-3535">
                      Конфликт
                    </div>
                    <div className="text-xs text-rose-600" data-id="element-3536">
                      {detailPanel.data.conflictReason}
                    </div>
                  </div>
                </div>}
            </div>}
        </div>
      </div>
    </div>;
}